<template>
  <div class="blocked-message">
    <h3>
      Het geselecteerde klantnummer is geblokkeerd en kan niet worden gebruikt.
    </h3>
    <p>
      Neem contact op met de administratie:<br />
      E-mail:
      <a href="mailto:debiteuren@rijnja.nl">debiteuren@rijnja.nl</a
      ><br />Telefoonnummer:
      <a href="tel:0302849300">
        030 2849300
      </a>
    </p>
  </div>
</template>

<style scoped lang="scss">
.blocked-message {
  h3 {
    color: var(--error-color);
    margin-bottom: 10px;
  }
  p {
    line-height: 24px;
  }
  border-radius: 25px;
}
</style>
